import React from 'react';
import PaginatedTable from '../../commonComponents/util/PaginatedTable';
import DuplicatesTableRow from './DuplicatesTableRow';

export default class DuplicatesTable extends React.Component {
    constructor(props) {
        super(props);

        this.getTableRow = this.getTableRow.bind(this);
    }

    getTableRow(duplicate) {
        return <DuplicatesTableRow key={duplicate.map(r => r.applicantId).join('-')}
            recipients={duplicate}
            viewDuplicatesDetails={this.props.viewDuplicatesDetails} />;
    }

    render() {
        return <PaginatedTable
            name="duplicate recipients"
            page={this.props.page}
            totalCount={this.props.data.totalCount}
            resultsView={this.props.resultsView}
            loading={this.props.loading}
            success={this.props.success}
            renderRow={this.getTableRow}
            columns={[
                { title: 'Name', sortable: false, id: 'name' },
                { title: 'Address', sortable: false, id: 'address' },
                { title: 'Phone', sortable: false, id: 'phone' }
            ]}
            records={this.props.data.records || []}
            // sortData={this.props.updateTable}
            changeDataView={this.props.updateTable}
            loadData={this.props.getDuplicates} />
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/manageDuplicates/DuplicatesTable.jsx